var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#73BD54",
    d: "M140 96c6,9 10,19 11,30 1,10 -1,21 -6,31 -5,9 -12,17 -21,23 -9,6 -19,9 -30,9 -11,0 -21,-3 -30,-8 -10,-6 -17,-14 -22,-23 -5,-10 -7,-20 -7,-31 1,-11 5,-21 11,-30l19 14c-4,5 -6,11 -6,18 -1,6 0,12 3,18 3,6 8,11 13,14 6,3 12,5 19,5 6,0 12,-2 18,-6 5,-3 10,-8 12,-14 3,-5 4,-12 4,-18 -1,-7 -3,-13 -7,-18l19 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73BD54",
    d: "M64 81c9,-6 20,-8 30,-8 11,0 21,3 30,9l-13 19c-5,-3 -11,-5 -17,-5 -7,0 -13,2 -18,5l-12 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73BD54",
    d: "M51 51c13,-9 28,-13 44,-13 16,0 31,5 45,14l-13 18c-9,-6 -21,-10 -32,-10 -11,0 -22,4 -32,10l-12 -19 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73BD54",
    d: "M33 17c19,-12 40,-18 62,-17 22,1 43,8 61,21l-14 19c-14,-10 -31,-16 -48,-16 -17,-1 -33,4 -48,13l-13 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.dfa5122b001398957bb093d3135f7bda.svg";
export { ForwardRef as ReactComponent };